// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://qotppvufvsnqdqvebaaq.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_K8vQUj2sKphI-gCuIULJ3A_0AoWiJns";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);